// extracted by mini-css-extract-plugin
module.exports = {"no-recruiter-access":"styles__no-recruiter-access___2Umbr","no-recruiter-access__contact":"styles__no-recruiter-access__contact___1GC3D"};